'use client';

import { createContext, useContext, type ReactNode } from 'react';
import type { LocaleType } from '@benzinga/translate';

const PageLocaleContext = createContext<LocaleType>('en');

export const PageLocaleProvider = ({ children, locale }: { children: ReactNode; locale: LocaleType }) => (
  <PageLocaleContext.Provider value={locale}>{children}</PageLocaleContext.Provider>
);

export const usePageLocale = (): LocaleType => useContext(PageLocaleContext);
